import { useAuth } from '../context/AuthContext';
import Cell from '../components/Cell';
import { Link } from 'react-router-dom';

export default function Home() {

  const currentUser = useAuth();

  return (
    <div>
        <h1>MOT MOT MOTUS</h1>
        <p>Jouez avec les mots !</p>

        {(currentUser !== null) ? (<p>Commencez par définir vos <a href="/prefs">préférences</a> de jeux</p>):''}

        <div>
          <Cell
              key={'1'}
              letter={'B'}
              status={'correct'}
            />
            La lettre est bien placée
        </div>
        <div>
          <Cell
              key={'1'}
              letter={'G'}
              status={'present'}
            />
            La lettre existe mais n'est pas bien placée
        </div>
        <div>
          <Cell
              key={'1'}
              letter={'K'}
              status={'absent'}
            />
            La lettre n'existe pas dans le mot
        </div>

        {(currentUser === null && false) ? (<p><Link to="/authent/register">Créez un compte</Link> ou <Link to="/authent/login">connectez-vous</Link></p>):''}
    </div>
  );
}